import React from "react";

import theme from "@/styles/themes/theme";
import { Stack, Typography } from "@mui/material";
import { ListMagnifyingGlass } from "@phosphor-icons/react";

const EmptyProductsList: React.FC = () => {
  return (
    <Stack direction="row" justifyContent="center" alignItems="center" height="40vh" spacing={2}>
      <ListMagnifyingGlass size={36} color={theme.palette.grey[500]} />

      <Typography variant="h5" color={theme.palette.grey[500]}>
        Nenhum produto encontrado
      </Typography>
    </Stack>
  );
};

export default EmptyProductsList;
